<template>
    <div class="container containerBox meterbox">
        <div class="handle-box">
            <el-form :inline="true" :model="handleForm" class="demo-form-inline">
                <el-form-item :label="$t('household.selectRes')" prop="residenceoid">
                    <cmp-build-select 
                        :buildRoom="buildRoom1"
                        changeOnSelect
                        @listenBuildResult="listenBuildResult1"></cmp-build-select>                   
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="add-meter-box">
            <el-button type="primary" size="medium" @click="addMeter" v-has="'device_parameters'">+ {{$t('meter.bindMeter')}}</el-button>
        </div>
<!--        <div class="table-box">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="TerminalSerial" label="表计序列号">
                </el-table-column>
                <el-table-column prop="house_name" label="安装位置" :formatter="fmtHouse">
                </el-table-column>
                <el-table-column prop="DevType" label="表计类型" :formatter="fmtDevType">
                </el-table-column>
                <el-table-column prop="DevModule" label="表计型号">
                </el-table-column>
                <el-table-column prop="CollectorName" label="所属集控器">
                </el-table-column>
                <el-table-column prop="CollectorSerial" label="集控器序列号">
                </el-table-column>
                <el-table-column prop="assigned_house_id" label="注册状态" :formatter="fmtStatus">
                </el-table-column>
                <el-table-column label="在线状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.OnlineStatus === 1 ? 'success': 'danger'">{{fmtOnlineStatus(scope.row)}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.operation')" v-has="'device_parameters'">
                    <template slot-scope="scope">
                        <el-button type="text" size="meduim" @click="handleReplace(scope.row)">替换</el-button>
                        <el-button type="text" size="meduim" @click="handleDelete(scope.row)">解除绑定</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div> -->
		<l-table
		    :list="tableData"
		    :total="total" 
		    :otherHeight="260" 
		    :options="options"
		    :pagination="pagination"
		    :columns="columns" 
		    :operates="operates"
		    @handleSizeChange="handleSizeChange"
		    @handleIndexChange="handleIndexChange">
		</l-table>
		
        <el-dialog title="替换表计" :visible.sync="dialogReplaceVisible">
            <el-form :inline="true">
                <div class="title">基本信息</div>
                <el-row :gutter="20" style="margin-bottom: 24px;">
                    <el-col :span="8">
                        <span>安装位置: {{replaceForm.house_name}}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>表计类型: {{replaceForm.strDevType}}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>表计型号： {{replaceForm.DevModule}}</span>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom: 24px;">
                    <el-col :span="8">
                        <span>所属集控器: {{replaceForm.Dev_Name}}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>注册状态：{{replaceForm.strStatus}}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>在线状态: {{replaceForm.strOnlineStatus}}</span>
                    </el-col>
                </el-row>
                <div class="title">替换信息</div>
                <el-form-item label="房间选择">
                    <div style="width:300px;">
                        <cmp-build-select :buildRoom="buildRoom" @listenBuildResult="listenBuildResult"></cmp-build-select>
                    </div>                    
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="primary" @click="handleSave" size="middle">确 定</el-button>
                <el-button @click="dialogReplaceVisible = false" size="middle">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import lTable from '@/components/lTable/lTable'
import Service from '@/api/Service';
import { $Alert,$Alertnew, funFmtDevType, fmtHouseInfo } from '@/utils/utils'
import CmpBuildSelectMeter from '@/components/CmpBuildSelect/CmpBuildSelectMeter'
import { mapGetters } from "vuex";

import CmpBuildSelect from '@/components/CmpBuildSelect/CmpBuildSelect'
export default {
    name: "BindMeter",
    inject: ["reload"],
    data() {
        return {
            tableData: [],
            // 替换表计表单
            replaceForm: {},
            houseoid: '',
            
            dialogReplaceVisible: false,    // 替换表计浮层
            buildRoom: {},
            buildRoom1: {},

            handleForm: {
                residenceoid: 0,
				is_house:false,
				buildingindex:0
            },
			options:{},
			columns: [
				{
					prop: 'terminal_serial',
					label: '表计序列号',
					align: 'center',
				},
				{
					prop: 'moduleid_list',
					label: '安装位置',
					align: 'center',
					formatter: (row, column, cellValue) => {
						return this.fmtHouse(row)
					}
				},	
				{
					prop: 'device_model',
					label: '表计类型',
					align: 'center',
					formatter: (row, column, cellValue) => {
						return this.fmtDevType(row)
					}
				},	
				{
					prop: 'device_model',
					label: '表计型号',
					align: 'center',
				},	
				{
					prop: 'collector_name',
					label: '所属集控器',
					align: 'center',
				},	
				{
					prop: 'collector_serial',
					label: '集控器序列号',
					align: 'center',
				},	
				{
					prop: 'devicetype',
					label: '注册状态',
					align: 'center',
					formatter: (row, column, cellValue) => {
						return this.fmtStatus(row)
					}
				},	
				{
					prop: 'devicetype',
					label: '在线状态',
					align: 'center',
					formatter: (row, column, cellValue) => {
						return this.fmtOnlineStatus(row)
					}
				},	
			], // 需要展示的列
			total: 0,
			pagination: {
				page_num: 1,
				page_sum: 10
			},
			operates: {
				width: 120,
				fixed: 'right',
				list: [
			       {
			            label: '解除绑定',
			            type: 'primary',
			            show: (index, row) => {
			                return true
			            },
			            icon: '',
			            plain: true,
			            disabled: (index, row) => {
			                return false
			            },
			            method: (index, row) => {
			                this.handleDelete(row);
			            },
			        },
			    ]
			}, // 操作按钮组
        };
    },
	computed: {
	    ...mapGetters(['projectsystemInfo']),
	    systemType() {
	        return this.projectInfo.sysid !== 2;
	    }
	},
    created() {
        this.getList();
    },
    components: {
        CmpBuildSelect,
		CmpBuildSelectMeter,
		lTable
    },
    methods: {
        // 获取数据
        async getList() {
			let params = {};
			params.moduleid=this.handleForm.residenceoid
			params.is_house=this.handleForm.is_house
			params.buildingindex=this.handleForm.buildingindex
			params.page_num=this.pagination.page_num
			params.page_sum=this.pagination.page_sum
            let data = await Service.getBindingMeter(params);
            if(data) {
                data = data =='success' ? [] : data;
                this.tableData = data.list
				this.total = data.total;
            }
        },
        // 查询
        onSubmit() {
            this.getList()
        },
        // 安装位置
        fmtHouse(row){
            return fmtHouseInfo(row.house_name, row.moduleid_list);
        },
        // 格式化表计类型
        fmtDevType(row) {
            return funFmtDevType(row.dev_type);
        },
        // 格式化注册状态
        fmtStatus(row) {
            return row.assigned_household_id > 0 ? "已注册" : "已绑定";
        },
        // 格式化在线状态
        fmtOnlineStatus(row) {
            switch (row.online_status) {
                case 1:
                    return '在线'
                case 2:
                    return '离线'
                default:
                    break;
            }
        },
        // 选择替换房间
        listenBuildResult(data) {
            // if(data.terminalid>0){
            //     this.$notify({
            //         title: '警告',
            //         message: '该房间已经绑定了表计，请重新选择！',
            //         type: 'warning'
            //     });
            //     return
            // }
			if(data.householdid === undefined) {
			    // 建筑
			    this.handleForm.is_house = false
			}else{
			    // 房间
			    this.handleForm.is_house = true
			}
            this.houseoid = data.oid;
        },
        // 最后一级房间确认信息
        listenBuildResult1(data) {
            if(data.householdid === undefined) {
                // 建筑
                this.handleForm.is_house = false
				if(data.next){
					let arr= JSON.parse(data.next)
					switch (arr.name){
						case '小区':
							this.handleForm.buildingindex = 2;
							break;
						case '楼层':
							this.handleForm.buildingindex = 3;
							break;
						default:
							this.handleForm.buildingindex = 1;
							break;
					}
				}else{
					this.handleForm.buildingindex = 0
				}
            }else{
                // 房间
                this.handleForm.is_house = true
				this.handleForm.buildingindex = 4
            }
            this.handleForm.residenceoid = data.oid || 0;
        },
        // 替换表计
        handleReplace(row) {
            row.strDevType = this.fmtDevType(row);
            row.strStatus = this.fmtStatus(row);
            row.strOnlineStatus = this.fmtOnlineStatus(row)
            this.replaceForm = row
            this.dialogReplaceVisible = true;
        },
        // 确认替换
        async handleSave() {
            let oid = this.houseoid;
            let terminalid = this.replaceForm.oid
            if(oid) {
                let data = await Service.meterReplaceHouse({oid:oid, terminalid:terminalid});   //  房间ID 表计ID
                if(data) {
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.dialogReplaceVisible = false;
                    this.reload();
                }
            }else{
                this.$notify({
                    title: '提示',
                    message: '请选择要替换的房间号！',
                    type: 'warning'
                });
                return
            }
        },
        // 解除绑定
        async handleDelete(row) {
			let data = await Service.getLastHouse({house_id:row.assigned_house_id})
			if(this.projectsystemInfo.sys_type_id != 0 || data == null || data == 'success'){
				let {house_name, oid, assigned_house_id} = row;
				$Alert(`确认解除${house_name}绑定, 是否继续?`).then( async (bool)=>{
				    if(bool){
				        let data = await Service.delBindingMeter({oid:assigned_house_id, terminalid:oid});
				        if(data) {
				            this.$message({
				                type: 'success',
				                message: '操作成功!',
				                duration: 1500,
				            });
				            this.reload();
				        }
					}   
				});
			}else{
				let settlementtime = data.settlement_time;
				let {house_name, oid, assigned_house_id} = row;
				$Alertnew(`该房间账单最近一次结算时间是${settlementtime},是否继续解除${house_name}绑定？`).then( async (bool)=>{
				    if(bool == '1'){
				        let data = await Service.delBindingMeter({oid:assigned_house_id, terminalid:oid});
				        if(data) {
				            this.$message({
				                type: 'success',
				                message: '操作成功!',
				                duration: 1500,
				            });
				            this.reload();
				        }
				    }else if(bool == '0'){
						this.$router.push({ path: "/readingmeter" });
					}  
				});
			}
			
            
        },
        // 切换页码
        handleSizeChange (pagination) {
            this.pagination = pagination
            this.getList()
        },
        // 切换页码
        handleIndexChange (pagination) {
            this.pagination = pagination
            this.getList()
        },
        addMeter() {
            this.$router.push("/meter/bind")
        },
    }
};
</script>

<style scoped>

/* .add-meter-box {
    margin-bottom: 24px;
} */
.title {
    padding: 4px;
    margin-bottom: 24px;
    font-size: 18px;
    border-bottom: 1px solid #dcdfe6;
}
</style>
